<template>
  <div class="d-flex align-items-stretch flex-shrink-0">
    <div
      v-if="!hasRole('ROLE_FORMS_MOBILE')"
      id="kt_header_vehicles_details_menu_toggle"
      class="d-flex align-items-center ms-1 ms-lg-3 justify-content-end"
      v-tooltip
      data-bs-toogle="tooltip"
      data-bs-placement="bottom"
      :title="$t('userMenu.buttons.history')"
      @click="openHistory"
    >
      <span
        v-if="route.name === 'Map'"
        class="icon fa-regular fa-chart-bar"
      />
    </div>
    <div
      v-if="!hasRole('ROLE_FORMS_MOBILE')"
      id="kt_header_assets_list_menu_toggle"
      class="d-flex align-items-center ms-1 ms-lg-3 justify-content-end"
      v-tooltip
      data-bs-toogle="tooltip"
      data-bs-placement="bottom"
      :title="$t('userMenu.buttons.assetsList')"
      @click="openAssetsList"
    >
      <span
        v-if="route.name === 'AssetsMap'"
        class="icon bi bi-list-ul"
      />
    </div>
    <div
      v-if="!hasRole('ROLE_FORMS_MOBILE')"
      id="kt_header_notifications_menu_toggle"
      class="d-flex align-items-center ms-1 ms-lg-3 justify-content-end position-relative"
      v-tooltip
      data-bs-toogle="tooltip"
      data-bs-placement="bottom"
      :title="$t('userMenu.buttons.notifications')"
      @click="openNotifications"
    >
      <span class="icon fa-regular fa-comment-dots" />
      <span
        v-if="unreadCount"
        class="badge"
      >{{ unreadCount }}</span>
    </div>
    <div
      :key="isDarkTheme"
      class="d-flex align-items-center ms-1 ms-lg-3 justify-content-end"
      v-tooltip
      data-bs-toogle="tooltip"
      data-bs-placement="bottom"
      :title="themeTooltip"
      @click="toggleTheme"
    >
      <i
        v-if="isDarkTheme"
        class="icon bi bi-moon-fill theme-icon"
      />
      <i
        v-else
        class="icon bi bi-sun-fill theme-icon"
      />
    </div>
    <div
      id="kt_header_user_menu_toggle"
      class="d-flex align-items-center ms-1 ms-lg-3 justify-content-end"
      v-tooltip
      data-bs-toogle="tooltip"
      data-bs-placement="bottom"
      :title="$t('userMenu.buttons.settings')"
      @click="openSettings"
    >
      <span class="icon fa-regular fa-circle-user" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watchEffect, onMounted, computed } from 'vue';
import {useRoute} from 'vue-router'
import {hasRole} from "@/utils/tools";

export default defineComponent({
  name: 'Topbar',
  data() {
    return {
      hasRole
    }
  },
  setup() {
    const route = useRoute()
    const unreadCount = ref(window.unreadNotifications);
    const isDarkTheme = ref(
      localStorage.getItem('digitrack_theme_dark') === 'true'
    );

    watchEffect(() => {
      unreadCount.value = window.unreadNotifications;
    });

    onMounted(() => {
      window.addEventListener('unreadNotificationsUpdated', () => {
        unreadCount.value = window.unreadNotifications;
      });

      // Inicjalizacja klasy dark-theme przy montowaniu komponentu
      if (isDarkTheme.value) {
        document.body.classList.add('dark-theme');
      }
    });

    const toggleTheme = async () => {
      // Ukryj wszystkie tooltips
      const tooltips = document.querySelectorAll('.tooltip');
      tooltips.forEach(tooltip => tooltip.remove());

      isDarkTheme.value = !isDarkTheme.value;
      localStorage.setItem('digitrack_theme_dark', isDarkTheme.value.toString());

      // Dodaj/usuń klasę dark-theme do body
      if (isDarkTheme.value) {
        document.body.classList.add('dark-theme');
      } else {
        document.body.classList.remove('dark-theme');
      }
    };

    const themeTooltip = computed(() => {
      return isDarkTheme.value ? 'Kliknij aby zmienić na tryb jasny' : 'Kliknij aby zmienić na tryb ciemny';
    });

    return {route, unreadCount, isDarkTheme, toggleTheme, themeTooltip};
  },
  methods: {
    openNotifications() {
      window.openSidebarWithComponent({level: 0, componentName: 'Notifications', title: this.$t('userMenu.buttons.notifications')})
    },
    openSettings() {
      window.openSidebarWithComponent({level: 0, componentName: 'User', title: this.$t('userMenu.buttons.settings')})
    },
    openHistory() {
      window.openSidebarWithComponent({level: 0, componentName: 'History', title: this.$t('userMenu.buttons.history')})
    },
    openAssetsList() {
      window.openSidebarWithComponent({level: 0, componentName: 'AssetsList', title: this.$t('userMenu.buttons.assetsList')})
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  font-size: 25px;
  color: #666;
  margin: 2px 5px 0 0;
  border-radius: 0.475rem;
  cursor: pointer;
  padding: 8px;

  &:hover{
    color: var(--primary-color);
  }
}

.badge {
  position: absolute;
  top: 0px;
  right: 0;
  background-color: var(--primary-color);
  border-radius: 50%;
  color: white;
  font-size: 12px;
  padding: 2px 5px;
  min-width: 16px;
  text-align: center;
}

.theme-icon {
  color: var(--primary-color);

  &:hover {
    color: var(--primary-color);
  }
}
</style>
